module.exports = __webpack_public_path__ + "images/canonical-card/comment-icon.488a6237f42e1c428b27.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/comment-icon.svg
// module id = 5hRm
// module chunks = 0